export default __webpack_public_path__ + "static/media/meal.2971f633.jpg";